import { WorksheetActionModelSelector } from '@autoinformer/helpers/worksheets/action-types';

export const WorksheetAction = {
  /**
   * @param entry_points
   * @param actions
   * @return {{items: *[]}}
   *
   * Единожди получаем с бека и отдаем форматтеру,
   * он преобразовывает ответ бекенда в модели из папки @autocaller/models/worksheet-action
   * Дальше уже работаем только с этими моделями
   */
  formatItemFromBackend(schema) {
    const transform_items = schema.map((item) => {
      const item_model = WorksheetActionModelSelector.getBackendModelByType(item.type, item);
      if (!item_model) {
        throw Error(`Unknown type: ${item.type}`);
      }
      return item_model.toFrontend();
    });
    
    return { items: transform_items };
  }
};
